

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface TenantPageParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}



export interface TenantPage {
    id?: string;
  tenantId: string;
  branchId: string;
  pageId: string;
  parameters?: TenantPageParameter[];
  links?: any;
}



export abstract class TenantPageData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<TenantPage[]>;
  abstract create(url: string,data: TenantPage[]): Observable<any>;
  abstract update(url: string,data: TenantPage): Observable<any>;
  abstract delete(url: string): Observable<any>;

}
